module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0021.jpg?v=eb269076";